var StatsColumns = function () {
    var stats = document.querySelectorAll('.stats-columns');

    if (!stats.length) {
        return;
    }

    /**
     * Reset and match heading heights inside each stats block.
     */
    var setHeadingHeights = function () {
        stats.forEach(function (stat) {
            var headings = stat.querySelectorAll('.stats-columns__wrap--heading');
            var tallest = 0;

            if (!headings.length) {
                return;
            }

            headings.forEach(function (heading) {
                heading.style.height = 'auto';

                var headingHeight = heading.offsetHeight;

                if (headingHeight > tallest) {
                    tallest = headingHeight;
                }
            });

            headings.forEach(function (heading) {
                heading.style.height = tallest + 'px';
            });
        });
    };

    setHeadingHeights();

    window.addEventListener('resize', function () {
        setHeadingHeights();
    });
};

export default StatsColumns;
